module.exports = __webpack_public_path__ + "img/update3.5_image07.e7e2edfe.png";